<div class = "mont-bold medium-font bottom-15 applicant-card">Hired Contractors</div>
  <ng-container *ngFor="let contractor of jobItem.confirmedContractorsList">
  <div class="applicant-card"> 
  <div class = "contractor-detail-card bottom-40"> 
    <app-shift-detail-container [staffer] = "contractor" [userData] = "userData" [viewingHired]="true"></app-shift-detail-container>
  </div>
  </div>
  </ng-container>
<app-pagination *ngIf = "jobItem?.staffersAndShifts?.length" [totalRecords] = "jobItem?.staffersAndShifts?.length"></app-pagination>
                          